import { ChangeEventHandler } from 'react';

export type InputProps = {
  className?: string;
  value?: string | number;
  disabled?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
  placeholder?: string;
  type?: 'text' | 'password' | 'number';
  maxLength?: number;
  inputMode?: 'text' | 'numeric';
};

const Input: React.FC<InputProps> = ({
  className,
  value,
  disabled = false,
  onChange,
  placeholder,
  type = 'text',
  maxLength,
  inputMode,
}) => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    if (!disabled && onChange) {
      onChange(event);
    }
  };

  return (
    <input
      type={type}
      value={value}
      disabled={disabled}
      className={className ?? 'border border-gray-500 px-1'}
      onChange={handleChange}
      placeholder={placeholder}
      maxLength={maxLength}
      inputMode={inputMode}
    />
  );
};

export default Input;
